import React from 'react';
import { ErrorPage } from '@noths/polaris-client-next-components';
import { DepartmentBanner, PreviewHeader } from '@noths/polaris-client-ribbons-design-system';
import getConfig from 'next/config';

import { HiddenPageTitle } from 'src/components/atoms/HiddenPageTitle/HiddenPageTitle';
import { Seo } from 'src/components/atoms/Seo/Seo';
import { Sections } from 'src/components/molecules/Sections/Sections';
import type { NextConfig } from 'src/types/NextConfig';
import type { ContentPageResultProps } from 'src/types/PageProps';
import type { SerializedUISection } from 'src/types/Section';
import * as styles from './RibbonsPage.styles';

const {
  publicRuntimeConfig: { CLEAR_PREVIEW_API_URL },
} = getConfig() as NextConfig;

const blockHasPageTitle = (blocks: SerializedUISection[]) =>
  blocks.some((block) => block.props.headingIsPageTitle);

export const RibbonsPage = (props: ContentPageResultProps) => {
  // Every content page renders through here, so this is the one place the 503
  // path from `getContentPageErrorResult` needs handling. It carries no
  // `pageContent`, hence the guard before destructuring rather than a default.
  if (props.hasError) {
    return <ErrorPage />;
  }

  const {
    pageContent: { departmentBanner, sections, seo, title },
    pageMetadata: { isPreview },
  } = props;

  const renderHiddenPageTitle = !blockHasPageTitle(sections);

  return (
    <div css={styles.container}>
      <Seo {...seo} />
      {departmentBanner && <DepartmentBanner {...departmentBanner} />}
      {renderHiddenPageTitle && <HiddenPageTitle>{title}</HiddenPageTitle>}
      {isPreview && <PreviewHeader href={CLEAR_PREVIEW_API_URL} />}
      {sections ? <Sections isPreview={isPreview} sections={sections} /> : null}
    </div>
  );
};
